export const GENRES = [
  {
    uri: "http://g2.dpa.com/cv/textgenre/14",
    name: "Text XXXXXX"
  },
  {
    uri: "http://g2.dpa.com/cv/textgenre/30",
    name: "Text XXXXXX"
  }
];

export const getGenreByURI = (genres = GENRES) => uri =>
  genres.find(g => g.uri === uri) ||
  uri.match(/^http:\/\/g2\.dpa\.com\/cv\/textgenre\//)
    ? { name: "Text XXXXXX" }
    : { name: null };
